import { Form } from "react-router-dom";
import React, { useState, useEffect, useRef, useCallback } from "react";
import { Button,Modal, Steps } from "antd";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import Grid2 from "@mui/material/Unstable_Grid2/Grid2";
import { createLocation, updateLocation } from "../../../global/utility/Utils";
import { deleteLocationEndPoint } from "../../../configuration";
import { getRandomUUID } from "../../../Token";
import ValidationIcon from "../../../global/components/ValidationIcon";
import {Input} from "@vds/inputs"
import {
  getInputClassNames,
  ErrorMessage,
} from "../../../global/components/ValidationIcon";
import { fetchOrganization, fetchLatLong } from "../../../global/utility/Utils";
import { debounce } from "lodash";
import { SearchBox } from "@mapbox/search-js-react";
import ToastNotification from "../../../global/components/ToastNotification";
import { Switch } from "antd";
import mapboxgl from "mapbox-gl";
import * as turf  from "@turf/turf";
import {MAX_CHAR_LIMITS,getCharLimitMsgIfExceeded} from "../../../global/constants/inputLimits";
import { resetLocationData } from "../../../store/actions/location";
import { handleClosePopupShipment } from "./locationUtils";
import { current } from "@reduxjs/toolkit";
import { mapboxToken, mapboxOwner, terrainId, satelliteId } from "../../../configuration";
import { addDesignedButtons } from "../../Shipments/CreateShipments/map-utils";

const CreateLocation = ({visible, closePopup, selectedCloneOrganization,state,onOrgCreated}) => {
  let navigate = useNavigate();
 // let { state } = useLocation();
  const mapBoxAccessToken = mapboxToken;

  const [dataList, setDataList] = useState([]);
  const [selectedItem, setSelectedItem] = useState(null);
  const [showDeleteloc, setShowDeleteLoc] = useState(false);
  const [deletelocation, setDeleteLocation] = useState(false);
  const [showNotification, setShowNotification] = useState(false);
  const [typeNotific, setTypeNotific] = useState("error");
  const [notificationProps, setNotificationProps] = useState({});
  const [msgNotific, setMsgNotific] = useState("");
  const mapContainerRef = useRef(null);
  const mapRef = useRef(null);
  const geofenceCenter = useRef(null);
  const [adjustGeofenceMap, setAdjustGeofenceMap] = useState(false);
  const [boundingBox, setBoundingBox] = useState(null);
  const boundingBoxRef = useRef(boundingBox);
  const centerRef = useRef([-74.533564, 40.725683]);
  const dispatch = useDispatch();
  
  useEffect(()=>{
    boundingBoxRef.current = boundingBox;
  }, [boundingBox])

  const initialFormData = {
    locationName: "",
    address: "",
    gpslocation: "",
    lattitude:'',
    longitude:'',
    disable: false,
    // orgId: org_id!==undefined?org_id:"",
    // locationtype: "Plant",
    geofench: 500,
    adjustGeofenceMap:false
  };
  const [formData, setFormData] = useState(initialFormData);
  useEffect(()=>{
    centerRef.current = {formData: formData, center : [formData?.longitude, formData?.lattitude]};
  },[formData?.longitude, formData?.lattitude, formData])
  useEffect(()=>{
    if(formData?.longitude==='' && formData?.lattitude==='' && formData?.adjustGeofenceMap===true){
        setFormData({ ...formData, address: "1 Verizon Way, Basking Ridge, New Jersey 07920, United States", gpslocation: "40.725683,-74.533564", longitude: -74.533564, lattitude: 40.725683 });
    }
  },[formData?.adjustGeofenceMap])
// At the top of your component
const formDataRef = useRef(formData);
useEffect(() => {
  formDataRef.current = formData;
}, [formData]);
  const [errors, setErrors] = useState({
    locationName: "initial",
    address: "initial",
    gpslocation: "initial",
    lattitude:"initial",
    longitude:"initial",
  });
  
  const validateCoord = (coord) => {
    if (coord && Array.isArray(coord)) {
      if (!isNaN(coord[0]) && !isNaN(coord[1])) {
        if (
          coord[0] >= -180 &&
          coord[0] <= 180 &&
          coord[1] >= -90 &&
          coord[1] <= 90
        ) {
          return true;
        }
        return false;
      }
      return false;
    } else {
      return false;
    }
  };

  const [mapBoxTheme, setMapBoxTheme] = useState({
    cssText: `
            .Input {
                height: 48px;
                font-size: 1rem;
                font-weight: 400;
                color: #212529;
                font-family: system-ui;
            }
            .ClearBtn {
                display: none !important;
            }
        `,
    variables: {
      unit: "14px",
      padding: "0.5em",
      border: "1px solid rgba(111, 113, 113, 1)",
      borderRadius: "4px",
      boxShadow: "none",
    },
  });

  const [rerender, setReRender] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => {
      setReRender(!rerender);
    }, 1000);
    return () => clearTimeout(timer);
  }, [formData.lattitude, formData.longitude, formData.geofench, mapRef.current]);


  const handleAdjustGeofenceMap = (val) => {
    setAdjustGeofenceMap(val);
    setFormData({
      ...formData,
      adjustGeofenceMap: val,
    })
  }

  const handleChange = (e) => {
    let { name, value } = e.target || { name: "address", value: e };
    let gpslocation = formData.gpslocation;
    if(name=="longitude"){
      gpslocation = `${formData?.lattitude},${value}`;
    }else if(name=="lattitude"){
      gpslocation = `${value},${formData?.longitude}`;
    }else if(name=="geofench"){
      if(!isNaN(value)){
        value = Math.floor(value);
      }
    }
    setFormData({ ...formData, [name]: value, gpslocation });
    let tempErrors = { ...errors };
    switch (name) {
      case "locationName":
        tempErrors.locationName = value ? "initial" : "Please enter a location name";
        break;
      case "address":
        tempErrors.address = value && value!=="" ? "" : "Please enter address";
        break;
      case "gpslocation":
        const gpsPattern = /^-?\d+(\.\d+)?$/;
        tempErrors.gpslocation = gpsPattern.test(value) ? "" : "Please enter a valid GPS location";
        break;
      case "geofench":
        const geofenchPattern = /^(0|[1-9][0-9]{0,5}|1000000)$/;
        tempErrors.geofench = value == 0 ? "radius can't be less than 1" : geofenchPattern.test(value) ? "" : "Kindly enter a valid value for geofence"
        break;
      default:
        break;
    }
    if (name === "locationName") {
      const charLimitMessage = getCharLimitMsgIfExceeded("CATEGORY_TEXT", value);
      if (charLimitMessage) {
        tempErrors.locationName = charLimitMessage;
      }
      if (value.trim() === "") {
        tempErrors.locationName = "Location name cannot be empty or only spaces";
      }
    }
    setErrors(tempErrors);
  };

  const handleFocus = async (e) => {
    if (formData.address !== "") {
      try {
        lataLongFetch(formData.address);
      } catch (error) {
        console.error("Error calling API:", error);
      }
    }
  };

  const lataLongFetch = debounce(async (address) => {
    try {
      const response = await fetchLatLong(address);
      if (response.success) {
        setFormData((prevFormData) => ({
          ...prevFormData,
          gpslocation:
            response?.locations[0]?.latitude +
            "," +
            response?.locations[0]?.longitude,
        }));
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  });

  function generateCircle(center, radius) {
    return turf.circle(center, radius, {
      steps: 80,
      units: 'meters'
    });
  }

  function gethandlePoint(center, radius) {
    return turf.destination(center, radius, 90, { units: 'meters' });
  }

  let isDraggingHandle = false;



  const mouseMoveHandler = useCallback((e) => {
    if (!isDraggingHandle) return;
    const { center } = centerRef.current;
    const lngLat = [e.lngLat.lng, e.lngLat.lat];
    const newRadius = turf.distance(center, lngLat, { units: 'meters' });
    const newCircle = generateCircle(center, newRadius);
    const newHandle = gethandlePoint(center, newRadius);
    mapRef?.current.getSource('geofence').setData(newCircle);
    mapRef?.current.getSource('radius-handle').setData(newHandle);
  }, [])

  const mouseUpHandler = useCallback(async (e) => {
    if (!isDraggingHandle) return;
    const { center, formData } = centerRef.current;
    mapRef.current.getCanvas().style.cursor = '';
    const lngLat = [e.lngLat.lng, e.lngLat.lat];
    const newRadius = turf.distance(center, lngLat, { units: 'meters' });
    setFormData({ ...formData, geofench: Math.floor(newRadius) });
    setErrors({ ...errors, geofench: '' });
    isDraggingHandle = false;
  }, [])

  const mouseDownHandler = useCallback((e) => {
    e.preventDefault();
    isDraggingHandle = true;
    mapRef.current.getCanvas().style.cursor = 'grabbing';
  }, [])

  const AddCircleToMap = () => {
    let center = [-74.533564, 40.725683];
    const latestFormData = formDataRef.current;
    if (latestFormData?.longitude && latestFormData?.lattitude) {
      center = [latestFormData?.longitude, latestFormData?.lattitude];
    }
    if (!validateCoord(center)) return;
    const radius = latestFormData?.geofench ? latestFormData?.geofench : 100;
    if(isNaN(radius) || radius<=0) return;
    let circle = generateCircle(center, radius);
    const handlePoint = gethandlePoint(center, radius);

    const AddLayerAndSource = () => {
      if (mapRef.current.getLayer('radius-handle-layer')) {
        mapRef.current.removeLayer('radius-handle-layer');
      }
      if (mapRef.current.getSource('radius-handle')) {
        mapRef.current.removeSource('radius-handle');
      }
      if (mapRef.current.getLayer('geofenceLayer')) {
        mapRef.current.removeLayer('geofenceLayer');
      }
      if (mapRef.current.getSource('geofence')) {
        mapRef.current.removeSource('geofence');
      }

      mapRef?.current.addSource('geofence', {
        type: 'geojson',
        data: circle
      });
      mapRef?.current?.addLayer({
        id: 'geofenceLayer',
        type: 'fill',
        source: 'geofence',
        paint: {
          'fill-color': '#088',
          'fill-opacity': 0.4
        }
      });
      mapRef?.current?.addSource('radius-handle', {
        type: 'geojson',
        data: handlePoint
      });

      mapRef?.current?.addLayer({
        id: 'radius-handle-layer',
        type: 'line',
        source: 'geofence',
        paint: {
          'line-color': '#0089EC',
          'line-width': 3,
          'line-dasharray': [3, 3]
        }
      });
    }

    if (mapRef.current.isStyleLoaded()) {
      AddLayerAndSource();
    } else {
      mapRef.current.once('styledata', () => {
        AddLayerAndSource();
      })
    }

    geofenceCenter.current?.remove();

    geofenceCenter.current = new mapboxgl.Marker({
      // draggable: true,
      element: document.createElement("div"),
    });
    geofenceCenter.current.getElement().innerHTML = `<div>
              <img src="/assets/geofence-center.svg" style="width:20.79px; height:20.79px" alt="geofence center point"/>
      </div>`;
    geofenceCenter.current.setLngLat(center).addTo(mapRef?.current);


    mapRef?.current?.off('mousedown', 'radius-handle-layer', mouseDownHandler);
    mapRef?.current?.off('mousemove', mouseMoveHandler);
    mapRef?.current?.off('mouseup', mouseUpHandler);

    mapRef?.current?.on('mousedown', 'radius-handle-layer', mouseDownHandler);
    mapRef?.current?.on('mousemove', mouseMoveHandler);
    mapRef?.current?.on('mouseup', mouseUpHandler);

    const boundingBox = turf.bbox(circle);
    setBoundingBox(boundingBox);
    mapRef?.current?.fitBounds(boundingBox, {
      padding: 100,
      duration: 1000
    });

  }

  useEffect(() => {
    if (!mapContainerRef.current) return;

    if (!mapboxgl.supported()) {
      console.error("WebGL is not supported in this browser. Map cannot be initialized.");
      return;
    }
    try {
      mapRef.current = new mapboxgl.Map({
        container: mapContainerRef.current,
        style: 'mapbox://styles/mapbox/streets-v11',
        center: [-74.533564, 40.725683],
        zoom: 6,
      });
    } catch (e) {
      console.error("Failed to initialize map:", e);
      return;
    }
    mapRef.current.addControl(new mapboxgl.NavigationControl({
      visualizePitch: true,
    }), "bottom-right");
    mapRef.current.addControl(new mapboxgl.FullscreenControl(), "top-right");
    mapRef.current.on('load', () => {
      addDesignedButtons(mapRef.current, terrainId, satelliteId, mapboxOwner, AddCircleToMap);
      AddCircleToMap();
    });

    const handleFullScreenChange = (e) => {
      if (mapRef.current) {
        setTimeout(() => {
          mapRef?.current?.fitBounds(boundingBoxRef.current, {
            padding: 100,
            duration: 1000
          });
        }, 100)
      }
    }
    const fullScreenEvents = [
      'fullscreenchange',
      'webkitfullscreenchange',
      'mozfullscreenchange',
      'MSFullscreenChange'
    ];
    fullScreenEvents.forEach(e => {
      document.addEventListener(e, handleFullScreenChange);
    });

    return () => {
      fullScreenEvents.forEach(e => {
        document.removeEventListener(e, handleFullScreenChange);
      });
      if (mapRef.current) {
        mapRef.current.remove();
      }
    }
  }, [mapContainerRef.current, adjustGeofenceMap]);


  useEffect(() => {
    if (!mapRef.current) return;
    AddCircleToMap();
  }, [adjustGeofenceMap, rerender]);

  const handleSubmit = async () => {
    let tempErrors = { ...errors };
    // tempErrors.locationName = formData.locationName
    //   ? "initial"
    //   : "Please enter a location name";
    const trimmedLocationName = formData.locationName?.replace(/\s{2,}/g, " ").trim();
    if (!trimmedLocationName) {
      tempErrors.locationName = "Location name cannot be empty or only spaces";
    } else {
      tempErrors.locationName = "initial";
    }
    tempErrors.address = formData.address ? "" : "Please enter address";
    if(!formData?.address){
      setMapBoxTheme((prev) => ({
      ...prev,
      variables: { ...prev.variables, border: "1px solid rgb(186, 38, 38)" },
    }));
    }
    tempErrors.gpslocation = formData.gpslocation
      ? ""
      : "Please enter GPS location";
    tempErrors.lattitude = formData.lattitude ? "" : "Please enter lattitude";
    tempErrors.longitude = formData.longitude ? "" : "Please enter longitude";

    setErrors(tempErrors);
    if (Object.values(tempErrors).some((x) => x !== "" && x !== "initial")) {
      setNotificationProps({
        type: 'error',
        message: 'Add location',
        description: 'invalid-form-data',
        duration: 1,
        style: { backgroundColor: '#FFECE0', color: '#155724' },
      });
      setShowNotification(true);
      setTimeout(() => {
        setShowNotification(false);
      }, 1000);
    } else {
      if(state !== null && selectedCloneOrganization){
        const newItem = { id: Date.now(), ...formData };
        const response = await createLocation(newItem);
        setDataList([...dataList, newItem]);
        if (Array.isArray(response) && response?.length > 0 && response[0]?.id) {
          setNotificationProps({
            type: 'success',
            message: 'Add location',
            description: `Location "${response[0]?.name || response?.tags[0]?.name}" created successfully`,
            duration: 1,
            style: { backgroundColor: '#d4edda', color: '#155724' },
          });
          setShowNotification(true);
          setTimeout(() => {
            onOrgCreated();
            setShowNotification(false);
            setFormData(initialFormData);
            dispatch(resetLocationData());
          }, 1000);
        } else {
          setNotificationProps({
            type: 'error',
            message: 'Add location',
            description: "Location created failed",
            duration: 1,
            style: { backgroundColor: '#FFECE0', color: '#155724' },
          });
          setShowNotification(true);
          setTimeout(() => {
            setShowNotification(false);
          }, 1000);
        }
      }else if (selectedItem && state?.createlocation == undefined) {
        const updatedList = dataList?.map((item) =>
          item.id === selectedItem.id ? formData : item
        );
        const response = await updateLocation({ ...formData });
        if (response?.id) {
          setNotificationProps({
            type: 'success',
            message: 'Edit location',
            description: `Location "${formData.locationName}" updated successfully`,
            duration: 1,
            style: { backgroundColor: '#d4edda', color: '#155724' },
          });
          setShowNotification(true);
          setTimeout(() => {
            dispatch(resetLocationData());
            setShowNotification(false);
            onOrgCreated();
          }, 1000);
        } else {
          setNotificationProps({
            type: 'error',
            message: 'Edit location',
            description: `Location updated failed`,
            duration: 1,
            style: { backgroundColor: '#FFECE0', color: '#155724' },
          });
          setShowNotification(true);
          setTimeout(() => {
            setShowNotification(false);
          }, 1000);
        }
      } else {
        const newItem = { id: Date.now(), ...formData };
        const response = await createLocation(newItem);
        setDataList([...dataList, newItem]);
        if (Array.isArray(response) && response?.length > 0 && response[0]?.id) {
          setNotificationProps({
            type: 'success',
            message: 'Add location',
            description: `Location "${response[0]?.name || response[0]?.tags[0]?.name}" created successfully`,
            duration: 1,
            style: { backgroundColor: '#d4edda', color: '#155724' },
          });
          setShowNotification(true);
          setTimeout(() => {
            onOrgCreated();
            setShowNotification(false);
            setFormData(initialFormData);
            dispatch(resetLocationData());
          }, 1000);
        } else {
          setNotificationProps({
            type: 'error',
            message: 'Add location',
            description: "Location created failed",
            duration: 1,
            style: { backgroundColor: '#FFECE0', color: '#155724' },
          });
          setShowNotification(true);
          setTimeout(() => {
            setShowNotification(false);
          }, 1000);
        }
      }
    }
  };

  const deleteLocation = () => {
    setShowDeleteLoc(true);
  };

  const onConfirm = async () => {
    setDeleteLocation(true);
    setShowDeleteLoc(false);

    const response = await fetch(deleteLocationEndPoint(), {
      method: "DELETE",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + sessionStorage.getItem("bearer_token"),
        "VZ-M2M-Token": getRandomUUID(),
      },
      body: JSON.stringify({
        accountName: sessionStorage.getItem("accountId"),
        tagId: state?.id,
      }),
    });
    const deleteLocationRsp = await response;
    if (deleteLocationRsp) {
      if (
        deleteLocationRsp?.status === 200 ||
        deleteLocationRsp?.status === 204
      ) {
        setTypeNotific("success");
        setMsgNotific("Location deleted successfully");
        setShowNotification(true);
        setTimeout(() => {
          navigate("/locationdetails");
        }, 1000);
      } else {
        setTypeNotific("error");
        setMsgNotific("Location deleted failed");
        setShowNotification(true);
      }
    }
  };
  const handleClose = () => {
    setShowNotification(false);
  };
  const onExit = () => {
    setDeleteLocation(false);
    setShowDeleteLoc(false);
    navigate(-1);
  };

  const handleSearchRetrieve = (res) => {
    if (
      res?.features &&
      res.features.length > 0 &&
      res.features[0]?.properties?.coordinates
    ) {
      setMapBoxTheme((prev) => ({
        ...prev,
        variables: { ...prev.variables, border: "1px solid rgb(99, 184, 132)" },
      }));

      const lattitude = res.features[0].properties.coordinates.latitude;
      const longitude = res.features[0].properties.coordinates.longitude;
      const tempErrors = {...errors};
      const lattitudePattern = /^(-?[0-8]?\d(\.\d+)?|90(\.0+)?)$/;
      tempErrors.lattitude = lattitudePattern.test(res.features[0].properties.coordinates.latitude) ? "" : "Kindly enter a valid value for lattitude";
      const longitudePattern = /^(-?(1[0-7]\d|[0-9]?\d)(\.\d+)?|180(\.0+)?)$/;
      tempErrors.longitude = longitudePattern.test(res.features[0].properties.coordinates.longitude) ? "" : "Kindly enter a valid value for longitude";
      setErrors(tempErrors);

      setFormData((prev) => ({
        ...prev,
        address: res.features[0].properties.full_address,
        gpslocation: `${res.features[0].properties.coordinates.latitude},${res.features[0].properties.coordinates.longitude}`,
        longitude: res.features[0].properties.coordinates.longitude,
        lattitude: res.features[0].properties.coordinates.latitude,
        disable: true
      }));
      setErrors((prev) => ({
        ...prev,
        gpslocation: "",
      }));
    }
  };

  const handleSuggestError = (res) => {
    if (res.suggestions.length === 0) {
      setMapBoxTheme((prev) => ({
        ...prev,
        variables: { ...prev.variables, border: "1px solid rgb(186, 38, 38)" },
      }));
      setErrors((prev) => ({
        ...prev,
        address: "Please Search valid address and select",
      }));
    }
  };

  const resetErrors = () => {
    setErrors({
      locationName: "initial",
      address: "initial",
      gpslocation: "initial",
      lattitude: "initial",
      longitude: "initial",
    })
  };

  useEffect(()=>{
    setMapBoxTheme((prev) => ({
      ...prev,
      variables: { ...prev.variables, border: "1px solid rgba(111, 113, 113, 1)" },
    }));

  },[visible]);
  useEffect(() => {
    if (state) {
      if (state.hasOwnProperty("org_name") && state.hasOwnProperty("org_id")) {
        setSelectedItem({
          organization: state?.org_name,
          orgId: state?.org_id,
          geofench:500
        });
        setFormData({
          organization: state?.org_name,
          orgId: state?.org_id,
          geofench:500
        });
      } else {
        setSelectedItem({
          locationName: selectedCloneOrganization ? "" : state?.name || state?.tags?.[0]?.name || "",
          address: state?.address || state?.tags?.[0]?.address || "",
          lattitude: Array.isArray(state?.tags) && state?.tags?.length > 0 && state?.tags[0]?.lat_value ? state?.tags[0]?.lat_value :  state?.lat_value || "",
          longitude: Array.isArray(state?.tags) && state?.tags?.length > 0 &&state?.tags[0]?.long_value ? state?.tags[0]?.long_value :  state?.long_value || "",
          gpslocation: Array.isArray(state?.tags) && state?.tags?.length > 0 && state?.tags[0]?.lat_value
            ? state?.tags[0]?.lat_value + "," + state?.tags[0]?.long_value
            : state?.lat_value + "," + state?.long_value || "",
          geofench: state?.radius || state?.tags[0]?.radius,
          adjustGeofenceMap: Array.isArray(state?.tags) && state?.tags?.length > 0 && state?.tags[0]?.adjustgeofencemap ? state?.tags[0]?.adjustgeofencemap :  state?.adjustgeofencemap
        });
        setAdjustGeofenceMap(Array.isArray(state?.tags) && state?.tags?.length > 0 && state?.tags[0]?.adjustgeofencemap ? state?.tags[0]?.adjustgeofencemap :  state?.adjustgeofencemap);
        setFormData({
          id: state?.id,
          kind: state?.kind === "ts.tag.site" ? state?.kind : state?.tags?.[0]?.kind || "",
          locationName: selectedCloneOrganization ? "" : state?.name || state?.tags[0]?.name || "",
          address: state?.address || state?.tags?.[0]?.address || "",
           lattitude: Array.isArray(state?.tags) && state?.tags?.length > 0 && state?.tags[0]?.lat_value ? state?.tags[0]?.lat_value : state?.lat_value || "",
          longitude: Array.isArray(state?.tags) && state?.tags?.length > 0 && state?.tags[0]?.long_value ? state?.tags[0]?.long_value : state?.long_value || "",
          gpslocation: Array.isArray(state?.tags) && state?.tags?.length > 0 && state?.tags[0]?.lat_value
            ? state?.tags[0]?.lat_value + "," + state?.tags[0]?.long_value
            : state?.lat_value + "," + state?.long_value ||  "",
          geofench: state?.radius || state?.tags[0]?.radius || "",
          adjustGeofenceMap: Array.isArray(state?.tags) && state?.tags?.length > 0 && state?.tags[0]?.adjustgeofencemap ? state?.tags[0]?.adjustgeofencemap :  state?.adjustgeofencemap
        });
      }
    }
  }, [state]);

  return (
    <>
       <Modal
      title=""
      open={visible}
      onCancel={() => {handleClosePopupShipment({closePopup, dispatch});setFormData(initialFormData);resetErrors();}}
      footer={[
        <Grid2
          container
          marginTop={0}
          marginBottom={0}
          spacing={2}
          columns={{ xs: 12 }}
        >
          <Grid2 item xs={12} sm={6} md={6} lg={6}>
            <div className="mb-0">
              <Button
                className="custom-button-cancel"
                type="default"
                onClick={() => {handleClosePopupShipment({closePopup,dispatch});setFormData(initialFormData);resetErrors();}}
                shape="round"
                style={{ fontWeight: "bold", width: "100%" }}
                size={"large"}
              >
                Cancel
              </Button>
            </div>
          </Grid2>
          <Grid2 item xs={12} sm={6} md={6} lg={6}>
            <div className="mb-0">
              <Button
                className="custom-button-save"
                type="primary"
                onClick={handleSubmit}
               shape="round"
                style={{
                  width: "100%",
                  backgroundColor: "black",
                  color: "white",
                  fontWeight: "bold",
                }}
                size={"large"}
              >
                 {state !== null ? "Save" : "Add"}
              </Button>
            </div>
          </Grid2>
        </Grid2>,
      ]}
      width={680}
    >
       {showNotification && (
          <ToastNotification
            type={notificationProps.type}
            message={notificationProps.message}
            description={notificationProps.description}
            duration={notificationProps.duration}
            style={notificationProps.style}
          />
        )}
       <div style={{ marginBottom: "5px", marginTop:"5px" }}>
        <h2 className={"font-face-vzb page-header-location"}>
          {state === null && 'Add location'}
          {state !== null && selectedCloneOrganization &&  'Add location' }
          {state !== null && !selectedCloneOrganization &&  'Edit location'}
        </h2>
      </div>
      <Form>
        <Grid2
          container
          marginTop={1}
          marginBottom={2}
          spacing={1}
          columns={{ xs: 12 }}
        >
            <Grid2 item xs={12} sm={12} md={12} lg={12} direction="row">
              <div className="mb-1">
                <label className="input-label-user">Location name</label>
                <div>
                  <Input
                    type="text"
                    id="locationName"
                    name="locationName"
                    value={formData.locationName}
                    maxLength={MAX_CHAR_LIMITS.CATEGORY_TEXT}
                    required={false}
                    onChange={handleChange}
                    error={errors.locationName !== "initial"}
                    errorText={errors.locationName !== "initial" ? errors.locationName : ''}
                  />
                </div>
            </div>
            <div className="mb-1">
              <label className="input-label-user">Address</label>
              <div className="input-container">
                <SearchBox
                  accessToken={mapBoxAccessToken}
                  options={{
                    language: "en",
                    country: "US,CA,MX",
                  }}
                  value={formData.address}
                  onChange={handleChange}
                  onRetrieve={handleSearchRetrieve}
                  onSuggest={handleSuggestError}
                  theme={mapBoxTheme}
                  className={getInputClassNames("address", formData, errors)}
                  id="address"
                  name="address"
                />
                <ValidationIcon
                  fieldName="address"
                  formData={formData}
                  errors={errors}
                />
              </div>
              <ErrorMessage fieldName="address" className={'ats-error-message-imp'} errors={errors} />
            </div>
            <Grid2 style={{display:"flex"}}>
                <div className="mb-1" style={{ width: "46%", marginRight: "3%" }}>
                  <label className="input-label-user">Lattitude</label>
                  <div className="input-container locationLatLong">
                    <Input
                      id={`lattitude`}
                      value={
                        formData.lattitude || ""
                      }
                      onChange={handleChange}
                      required={false}
                      readOnly={true}
                      type="number"
                    />
                  </div>
                  <ErrorMessage fieldName="lattitude" className={'ats-error-message-imp'} errors={errors} />
                </div>
                <div className="mb-1" style={{ width: "46%", marginRight: "3%" }}>
                  <label className="input-label-user">Longitude</label>
                  <div className="input-container locationLatLong">
                    <Input
                      id={`longitude`}
                      value={
                        formData.longitude || ""
                      }
                      onChange={handleChange}
                      required={false}
                      readOnly={true}
                      type="number"
                    />
                  </div>
                  <ErrorMessage fieldName="longitude" className={'ats-error-message-imp'} errors={errors} />
                </div>
                <div className="mb-1" style={{ width: "46%" }}>
                  <label className="input-label-user">Geofence Radius(meters)</label>
                  <div className="input-container">
                    <Input
                      type="text"
                      id="geofench"
                      name="geofench"
                      value={formData.geofench}
                      onChange={handleChange}
                      error={!!errors.geofench}
                      errorText={errors.geofench}
                    />
                  </div>
                </div>
            </Grid2>
            <div
              className="d-flex flex-row justify-content-start align-items-center"
              style={{
                padding: "8px 0px",
                margin: "4px 0px",
              }}
            >
                <div
                  className="font-face-vzw"
                  style={{
                    fontWeight: 700,
                    fontSize: "16px",
                  }}
                >
                  Adjust geofence on map
                </div>
                <div className="px-2">
                  <Switch
                    style={
                      formData?.adjustGeofenceMap
                        ? {
                            backgroundColor: "#008331",
                          }
                        : {
                            backgroundColor: "#d8dada",
                          }
                    }
                    checked={formData?.adjustGeofenceMap}
                    onChange={(e)=>handleAdjustGeofenceMap(e)}
                  />
                </div>
              </div>
              {<div className={`w-100 d-flex flex-column justify-content-center align-items-start map-container ${formData?.adjustGeofenceMap?'mapContainerDisp':'mapContainerNotDisp' }`}><div 
                ref={mapContainerRef}
                style={{ width: "100%", height: "364px", borderRadius:'8px' }}
              >
                
              </div>
              <p style={{'color':'#6f7171', 'fontSize':'12px', 'lineHeight':'16px', 'fontWeight':'400', padding:'6px'}}>Click on the circumference and drag it to change the radius.</p>
              </div>}
          </Grid2>
        </Grid2>
      </Form>
      </Modal>
    </>
  );
};

export default CreateLocation;
